module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Chapters"
  }, [_c('span', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph"
  }, [_vm._v("I "), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("leaned back in my chair. “Well, that’s a relief. For a second, I thought you actually had some evidence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("That knocked the wind out of Agent Devereaux. “What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“You’re lying. You know what I’ve learned on the road these last few years…it’s how to read people. You’re bluffing. You’re working under the theory that I killed both people. Most serial killers have a signature, something unique to the way they kill. You guessed mine was cutting out the heart. Accordingly, you lied about finding her body, trying to make it believable by adding my supposed signature to it. You want to rattle me…you were doing a better job when you stuck to the facts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“You’re wrong, Mr. Fisher. Massachusetts State Police found her corpse two weeks ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Agent Devereaux, I’m sure you are an amazing agent and that you’re very good at your job. But your theory is flawed. I didn’t kill the store clerk, which means I didn’t remove his heart, which means it’s not my signature.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“And Sarai? Are you admitting you killed her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Not to you. Hell, I can’t even get him to admit it to himself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Agent Devereaux, again, I’m sure you’re a good investigator, but I’m well past my twenty-four hour holding period on that subject. If that’s all you’re going to ask me about, I assume I’m free to go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She was about to answer when there was a knock at the door. When it opened, an older Hispanic man came in, his attire suggesting that he too lived on a federal salary. Agent Devereaux stood up, looking frustrated. “Sir, I can handle this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He waved her off with his hand. She quickly left us, anger flashing in her stride. He gazed at me, curious, but waited till the door slammed shut before speaking. “I’m Supervisory Special Agent Rick Salazar.” He didn’t offer his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Colin Fisher, murder suspect,” I snarked.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Mr. Fisher, you’re free to go. I’d like you to know that up front. Your lawyer is downstairs waiting for you. You don’t have to say a thing to me without her present if you don’t want to. But I’d like to talk to you, if you’re willing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“My lawyer?” I was genuinely confused. They hadn’t offered a phone call, because I wasn’t formally under arrest. I was shocked to hear I had a lawyer at all, much less one that was physically in the building.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Can we talk? Off the record?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I nodded. “Sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“First, you have my condolences. There’s no easy way to say this, so I’ll come right out with it. Your father passed away last night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I almost said, “I know,” but I didn’t. Instead, I nodded again. “It’s for the best. I heard he was in a lot of pain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Agent Salazar sat down in the chair across from me. Our eyes met, but neither of us broke contact after the socially-sanctioned few seconds. His irises were a greyish blue flecked with purple and I felt a strange sense of safety and comfort in them. When he did break the gaze, he said, “I’m worried about you, Mr. Fisher. I’m afraid we may meet again in a room like this. Do you know why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I don’t know what happened to Sarai.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Yes, you do. Want me to tell you all about it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He shook his head. “Maybe you don’t. But that’s not why I’m worried. Isolation, Colin…it’s the only symptom shared by every mental disorder. Without social connections, a support system, the mind can start playing tricks on you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Internally, ")]), _c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("Y")]), _c('span', {
    staticClass: "C_ItalicsCH__And__Georgia"
  }, [_vm._v("ou’re telling me")]), _c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v(" Externally, “I’ll make it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He continued, as if I hadn’t spoken. “Factor in your intelligence, your choice of reading materials, and the losses you’ve endured…If you start losing your grip on reality and morality, you could be a very dangerous man. There are some profilers in the other room who think you already may be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Then why are you letting me go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Because you didn’t do this. Not the store clerk, not the others. But, Mr. Fisher,” he held out a business card in his hand, “If you ever want help, call me. If you get in over your head and you want out, there are people who can help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I tucked the card away in my jeans pocket. “I thought psychopathy was incurable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("He smiled, but it was a sad smile. “You’re not a psychopath. You empathized with Agent Devereaux. It’s how you got past her act; you sensed what she was really feeling instead of merely what she was showing. You’re not a psychopath…but that doesn’t mean you couldn’t be a monster. Some of the worst predators are the ones who use their empathy to find the vulnerability in their victims.” He locked eyes with me again. “Have you killed anyone yet, Mr. Fisher?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I believe you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I looked away from his gaze. “Then why…?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“…are we talking?” He thought about it for a minute, the silence between us comfortable, not cop and suspect in interrogation. “I helped with the aftermath of the Columbine shootings early in my career. The more I learned about it, the more I wondered if the right person at the right time could have helped those boys do something different. I never met them. But I’m meeting you. If I can be that person, I want you to call me when the time is right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Look, I think I’ve got everything under control. But if I start to lose it...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Start? We’re well out of the starting gate of insanity, my friend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“…I’ll call you. I promise.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I stood up, ready to see this mysterious lawyer of mine and hunt down some dinner. “So how did they figure out I didn’t kill that guy anyway?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Agent Salazar looked grim. “There was another killing while you were in custody. Same MO.” He shook his head. “Go bury your father, Mr. Fisher. Try and forget about this mess.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36800686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0014.vue
// module id = 102
// module chunks = 0